import { PuxIcon, PuxItem, PuxTypography } from "@phonero/pux-react"
import { questionmark } from "@phonero/pux-icons/icons"
import css from "./style.module.scss"

export const Input = ({
  label,
  children,
  required,
  ...rest
}: {
  required?: boolean
  label: React.ReactNode
} & JSX.IntrinsicElements["label"]) => {
  return (
    <PuxTypography
      component="label"
      variant="label"
      {...(rest as any)}
      className={css.label}
      onClick={() => {
        const id = rest.htmlFor
        if (!id) {
          return
        }
        const el = document.getElementById(id)
        if (!el) {
          return
        }
        el.click()
      }}
    >
      {label}
      <RequiredSpan required={required} />
      {!!children && <PuxItem>{children}</PuxItem>}
    </PuxTypography>
  )
}

export const RequiredSpan = ({
  required,
}: {
  required: boolean | null | undefined
}) => {
  // const {t} = useTranslation()
  if (typeof required !== "boolean") {
    return null
  }
  return <span>{required ? "*" : " (valgfritt)"}</span>
}

export const HelpIcon = ({ text }: { text: string }) => {
  if (!text) {
    return null
  }
  return (
    <div slot="end" title={text} style={{ zIndex: 10 }}>
      <PuxIcon color="primary" icon={questionmark} />
    </div>
  )
}
